import React from "react";

import AppRoutes from "../routes";
import Header from "../components/lourve/mth/header";
import Footer from "../components/lourve/mth/footer";
import HomePage from "../pages/lourve/home_page";
// import Header from "../components/lourve/layouts/header";
// import Footer from "../components/lourve/layouts/footer";

const LourveTemplate = () => {
  return (
    <>
      {/* <Header /> */}
      <AppRoutes homePage={HomePage} />
      <Footer />
    </>
  );
};

export default LourveTemplate;
